import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

export interface Config {
  textfile: string;
}

@Injectable()
export class SendemailService {
  sendgridUrl = 'https://lmht2ze4p4.execute-api.ap-northeast-1.amazonaws.com/default/send_an_email';

  constructor(private http: HttpClient) { }

  // メール送信
  sendEmail() {
    console.log("KANO send a SendGrid mail");
    return this.http.get<Config>(this.sendgridUrl)
      .pipe(
        retry(1), // retry a failed request up to 3 times
        catchError(this.handleError) // then handle the error
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };

}
